/**
 * Quels thèmes enregistrés sont des thèmes SOMBRES.
 *
 * Presque tout le sombre se joue dans les jetons : un composant lit `theme.colors[...]` et suit
 * le thème sans rien savoir. Reste ce qu'aucune couleur ne peut porter — le dessin du logo (le
 * mot « Masteur » est marine sur la version claire, blanc sur la version nuit) et le contenu de
 * la barre d'état. Ces deux-là ont besoin de savoir de quel côté on est, et c'est la seule
 * question qu'ils ont le droit de poser au thème.
 *
 * La liste vit ici, et pas dans un `theme.scheme` : sur le web, Unistyles sert les valeurs du
 * thème en variables CSS (`var(--colors-…)`), donc une chaîne lue dans le thème ne peut pas être
 * comparée en JavaScript. Le nom du thème, lui, est une vraie chaîne des deux côtés.
 */
export type ColorScheme = "light" | "dark"

/** Les thèmes sombres enregistrés dans `unistyles.ts`. Un univers sombre de plus = une ligne. */
export const DARK_THEME_NAMES = ["parentDark", "studentDark", "tutorDark"] as const

export function isDarkThemeName(name: string | undefined): boolean {
    return name != null && (DARK_THEME_NAMES as readonly string[]).includes(name)
}
